export interface Discount {
  discountProfileCode: string;
  discountTerm: number;
  discountAmount: number;
  discountPercentage: number;
}
